import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as mutations from './mutations'
let Base64 = require('js-base64').Base64;
import { decrypt, getCookie } from "../utils"

Vue.use(Vuex)

const store = new Vuex.Store({
  actions,
  mutations,

  state: {
    goods: {},
    product: {},
    assess: localStorage.assess !== undefined ? JSON.parse(localStorage.assess) : {},
    brands: [],
    zhima: {},
    stats: {},
    iscity: {},
    source: 0,
    user: getCookie("account") !== undefined && getCookie("account") !== "" ? JSON.parse(decrypt(getCookie("account"))) : {},
    ordersn: {},
    articles: [],
    orders: [],
    order: {},
    cancel: {},
    express: {},
    test: {},
    comment: {},
    status: {},
    article: {},
    hotword: [],
    recent: [],
    cart: {},
    map: {},
    bonus: [],
    bonuslist: [],
    atbonus: {},
    token: {},
    agent: {},
    wallet: {},
    wallets: {},
    rewallet: {},
    account: [],
    sms: {},
    region: [],
    invite: {},
    oldnews: {},
    oldnew: {}
  },
  getters: {}
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js